<template>
    <div class="uik-tab__container">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikTabContainer"
}
</script>

<style lang="scss">
.uik-tab__container {
  display: flex;
  padding: 0 15px;
  flex-shrink: 0;
  &:not(:last-child) {
    border-bottom: $borderDefault;
  }
}
</style>
